import { HoverCard, Group } from "@mantine/core"
import { IconHelp } from "@tabler/icons-react"
import { ReactElement, ReactNode } from "react"

type Props = {
  icon?: ReactElement<SVGElement> | ReactNode
  children: ReactNode
  maw?: number | string
}

export const HelpHover = ({ children, icon, maw = "32rem" }: Props) => {
  return (
    <HoverCard>
      <HoverCard.Target>
        <Group wrap="nowrap" align="center">
          {icon || <IconHelp color="gray" height={16} strokeWidth={1.5} />}
        </Group>
      </HoverCard.Target>
      <HoverCard.Dropdown maw={maw}>{children}</HoverCard.Dropdown>
    </HoverCard>
  )
}
